// extracted by mini-css-extract-plugin
export default {"div__1":"CreateAcc_div__1__QAuAc","div__2":"CreateAcc_div__2__26252","input__1":"CreateAcc_input__1__LI+0O","button":"CreateAcc_button__bZzOG","div__3":"CreateAcc_div__3__x2ch4"};